module.exports = __webpack_public_path__ + "img/menu-barcode-scan.639d261b.svg";